import { lazyLoad } from 'utils/loadable';

export const Login = lazyLoad(
  () => import('./login.page'),
  (module) => module.Login
);
